export default {
    EM_FILA: {texto: 'Em Fila', valor: 'EM_FILA'},
    PROCESSADO_ERRO: {texto: 'Processado com Erro', valor: 'PROCESSADO_ERRO'},
    PROCESSADO_SUCESSO: {texto: 'Processado com Sucesso', valor: 'PROCESSADO_SUCESSO'}
}